export default {
  common: {
    appName: 'UniPortal',
    byUnifiber: 'par Unifiber',
    copyright: '© {{year}} Unifiber — UniPortal',
    nav: { documents: 'Documents', publishing: 'Publication', collections: 'Collections', channels: 'Dossiers de dépôt', users: 'Utilisateurs', publishers: 'Catégories', guide: 'Guide' },
    signOut: 'Se déconnecter',
    loading: 'Chargement…',
    cancel: 'Annuler',
    save: 'Enregistrer',
    close: 'Fermer',
    search: 'Rechercher',
    retry: 'Réessayer',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    uncategorized: 'Non catégorisé',
  },
  auth: {
    login: {
      title: 'Connexion',
      subtitle: 'Accédez aux documents partagés avec vous',
      emailLabel: 'Adresse e-mail',
      emailPlaceholder: 'vous@entreprise.com',
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: 'Votre mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      signIn: 'Se connecter',
      signingIn: 'Connexion…',
      or: 'OU',
      microsoftSso: 'Se connecter avec Microsoft',
      ssoUnavailable: "La connexion Microsoft n'est pas disponible",
      errorBothFields: 'Veuillez saisir votre e-mail et votre mot de passe.',
      errorGeneric: 'Échec de la connexion. Veuillez réessayer.',
      ssoErrors: {
        denied: "La connexion Microsoft a été refusée. Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.",
        server_error: 'La connexion Microsoft est temporairement indisponible. Veuillez réessayer plus tard.',
        unknown: 'La connexion Microsoft a échoué. Veuillez réessayer.',
      },
      noAccount: 'Les comptes sont créés par votre administrateur.',
    },
    twofactor: {
      title: 'Authentification à deux facteurs',
      subtitle: "Saisissez le code à 6 chiffres de votre application d'authentification",
      verify: 'Vérifier',
      verifying: 'Vérification…',
      rememberDevice: 'Se souvenir de cet appareil pendant 30 jours',
      useRecovery: 'Utiliser un code de récupération',
      recoveryTitle: 'Code de récupération',
      recoverySubtitle: 'Saisissez un de vos codes de récupération à usage unique',
      recoveryPlaceholder: 'ex. A1B2C3D4',
      backToCode: "Retour au code d'authentification",
      remainingCodes: '{{count}} codes de récupération restants',
      invalidCode: 'Code invalide. Veuillez réessayer.',
      sessionExpired: 'Votre session de connexion a expiré. Veuillez revenir en arrière et vous reconnecter.',
      backToLogin: 'Retour à la connexion',
    },
    totpSetup: {
      title: "Configurer l'authentification à deux facteurs",
      subtitle: 'Protégez votre compte avec une application d’authentification',
      step1: 'Scannez ce QR code avec votre application (Microsoft Authenticator, Google Authenticator, …)',
      manualEntry: 'Ou saisissez cette clé manuellement :',
      step2: "Saisissez ensuite le code à 6 chiffres de l'application pour confirmer",
      confirm: 'Confirmer',
      confirming: 'Confirmation…',
      recoveryTitle: 'Enregistrez vos codes de récupération',
      recoverySubtitle:
        "Chaque code permet une connexion unique si vous perdez l'accès à votre application. Conservez-les en lieu sûr — ils ne seront plus affichés.",
      download: 'Télécharger .txt',
      copy: 'Copier',
      copied: 'Copié',
      savedConfirm: "J'ai enregistré mes codes de récupération",
      continue: 'Continuer vers UniPortal',
    },
    forceChange: {
      title: 'Définir un nouveau mot de passe',
      subtitle: 'Votre mot de passe a expiré et doit être modifié',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le nouveau mot de passe',
      mismatch: 'Les mots de passe ne correspondent pas.',
      submit: 'Changer le mot de passe',
      submitting: 'Modification…',
      policy: {
        minLength: 'Au moins 12 caractères',
        upper: 'Une lettre majuscule',
        lower: 'Une lettre minuscule',
        number: 'Un chiffre',
      },
    },
    forgot: {
      title: 'Réinitialiser votre mot de passe',
      subtitle: 'Saisissez votre adresse e-mail et nous vous enverrons un lien de réinitialisation',
      submit: 'Envoyer le lien',
      submitting: 'Envoi…',
      sentNote: 'Si un compte existe avec cet e-mail, un lien de réinitialisation a été envoyé.',
      backToLogin: 'Retour à la connexion',
    },
    reset: {
      title: 'Choisir un nouveau mot de passe',
      subtitle: 'Définissez le nouveau mot de passe de votre compte',
      totpLabel: "Code d'authentification",
      totpNote: 'Ce compte utilise la double authentification — saisissez le code à 6 chiffres de votre application.',
      submit: 'Réinitialiser le mot de passe',
      submitting: 'Réinitialisation…',
      success: 'Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter.',
      goLogin: 'Aller à la connexion',
      invalid: 'Ce lien de réinitialisation est invalide ou a expiré.',
    },
  },
  dashboard: {
    greeting: 'Bonjour {{name}}',
    title: 'Vos documents',
    subtitle: 'Tout ce qui est partagé avec vous, au même endroit.',
    searchPlaceholder: 'Filtrer par titre ou collection…',
    ungrouped: 'Autres documents',
    open: 'Ouvrir',
    updated: 'Mis à jour le {{date}}',
    emptyTitle: 'Aucun document pour le moment',
    emptyBody: "Aucun document n'a encore été partagé avec vous — veuillez contacter votre administrateur.",
    errorLoad: "Vos documents n'ont pas pu être chargés.",
    retry: 'Réessayer',
    noMatches: 'Aucun document ne correspond à votre filtre.',
  },
  viewer: {
    loading: 'Ouverture du document…',
    unavailableTitle: 'Document indisponible',
    unavailableBody: "Ce document n'est plus disponible, ou votre accès a changé.",
    backToDocuments: 'Retour aux documents',
    reload: 'Recharger le document',
  },
  publish: {
    title: 'Publication',
    subtitle: 'Téléversez des documents HTML autonomes et gérez qui peut les lire.',
    publisherLabel: 'Catégorie',
    publisherScopeHint: "Les documents et collections ci-dessous appartiennent à cette catégorie. Les destinataires sont choisis dans tout l'annuaire des utilisateurs.",
    noPublisher: "Votre compte n'administre aucune catégorie. Contactez l'administrateur de la plateforme.",
    upload: {
      title: 'Publier un document',
      drop: 'Glissez-déposez un fichier HTML ici',
      browse: 'ou parcourir',
      titleLabel: 'Titre (optionnel — par défaut le nom du fichier)',
      titlePlaceholder: 'ex. Rapport hebdomadaire — Circet',
      expiryLabel: "Date d'expiration (optionnelle)",
      grantsLabel: "Donner l'accès à",
      grantsHint: "Vous pouvez aussi gérer l'accès après la publication.",
      submit: 'Publier',
      uploading: 'Publication…',
      success: '« {{title}} » a été publié.',
      validatorOk: 'Vérification « autonome » réussie.',
      validatorWarn: 'Avertissement : références externes détectées ({{count}}). Le bac à sable les bloque à la lecture.',
      onlyHtml: 'Seuls les fichiers .html sont acceptés.',
      noGrantsWarn: 'Publié — mais partagé avec personne. Utilisez « Gérer l’accès » pour donner accès à des lecteurs.',
      collectionLabel: 'Collections',
      collectionHint: 'optionnel — une ou plusieurs',
      noCollection: '— aucune (non groupé) —',
      noCollectionsYet: 'Aucune collection — le document ira dans « Non catégorisé ».',
      dupSameDept: 'Ce document est déjà publié dans cette catégorie.',
    },
    docs: {
      title: 'Documents publiés',
      empty: 'Rien de publié pour le moment. Votre premier document apparaîtra ici.',
      notShared: 'Non partagé',
      notSharedHint: 'Publié mais accordé à personne — aucun lecteur ne peut le voir.',
      cols: {
        title: 'Titre',
        status: 'Statut',
        selfContained: 'Autonome',
        version: 'v',
        updated: 'Mis à jour',
        access: 'Accès',
        actions: '',
      },
      manageAccess: "Gérer l'accès",
      edit: 'Modifier',
      users: '{{count}} utilisateurs',
      ownerDept: 'Catégorie propriétaire',
      linkedDept: 'Catégorie liée',
    },
    edit: {
      title: 'Modifier le document',
      titleLabel: 'Titre',
      displayNameLabel: "Nom d'affichage pour votre catégorie (optionnel)",
      secondaryHint: "Ce document appartient à une autre catégorie. Vous pouvez gérer ses collections et son accès pour votre catégorie et lui donner votre propre nom d'affichage — mais pas changer son titre ni le supprimer.",
      collectionLabel: 'Collections',
      expiryLabel: "Date d'expiration (optionnelle)",
      save: 'Enregistrer',
      saved: 'Document mis à jour.',
      unlink: 'Retirer de ma catégorie',
      unlinkConfirm: 'Retirer ce document de votre catégorie ? Il reste disponible pour sa catégorie propriétaire.',
      unlinked: 'Retiré de votre catégorie.',
    },
    link: {
      title: 'Ce document existe déjà',
      subtitle: '« {{title}} » a déjà été publié par {{owner}}. Liez-le à vos collections au lieu d’en téléverser une copie.',
      nameLabel: "Nom d'affichage pour votre catégorie (optionnel)",
      namePlaceholder: 'Garder le titre original',
      collectionsLabel: 'Ajouter à vos collections',
      submit: 'Lier à ma catégorie',
      success: 'Document lié à votre catégorie.',
    },
    status: { PUBLISHED: 'Publié', DRAFT: 'Brouillon', EXPIRED: 'Expiré', DELETED: 'Supprimé' },
    access: {
      title: 'Qui peut lire « {{title}} » ?',
      subtitle: 'Toute personne de la plateforme peut recevoir l’accès à ce document.',
      searchUsers: 'Filtrer les utilisateurs…',
      noUsers: 'Aucun utilisateur sur la plateforme — créez-les dans Utilisateurs.',
      save: "Enregistrer l'accès",
      saved: 'Accès mis à jour : {{added}} ajouté(s), {{removed}} retiré(s).',
    },
  },
  admin: {
    title: 'Utilisateurs',
    subtitle: 'Comptes externes pouvant se connecter à UniPortal.',
    create: 'Nouvel utilisateur',
    searchPlaceholder: 'Rechercher un nom, e-mail ou entreprise…',
    cols: {
      name: 'Nom',
      company: 'Entreprise',
      auth: 'Connexion',
      publishers: 'Catégories',
      status: 'Statut',
      twofa: '2FA',
      lastLogin: 'Dernière connexion',
    },
    active: 'Actif',
    inactive: 'Inactif',
    never: 'Jamais',
    platformAdmin: 'Admin plateforme',
    allPublishers: 'Toutes les catégories',
    dialog: {
      createTitle: 'Créer un utilisateur',
      editTitle: 'Modifier l’utilisateur',
      saveChanges: 'Enregistrer',
      email: 'Adresse e-mail',
      displayName: "Nom d'affichage",
      company: 'Entreprise (optionnel)',
      language: 'Langue',
      authType: 'Méthode de connexion',
      authTypes: {
        LOCAL: 'Mot de passe + authentificateur (utilisateur externe)',
        ENTRA_ID: 'SSO Microsoft uniquement',
        BOTH: 'SSO Microsoft ou mot de passe',
      },
      publisher: 'Catégorie',
      noPublisherOption: '— aucun —',
      publisherRole: 'Rôle dans la catégorie',
      publisherRoles: { VIEWER: 'Lecteur', PUBLISHER_ADMIN: 'Admin éditeur' },
      role: 'Rôle plateforme',
      roles: { VIEWER: 'Standard', PLATFORM_ADMIN: 'Admin plateforme' },
      userType: 'Type d’utilisateur',
      userTypes: { REGULAR: 'Utilisateur standard', PUBLISHER: 'Éditeur', ADMIN: 'Administrateur' },
      department: 'Catégorie',
      departmentPlaceholder: '— choisir —',
      categories: 'Catégories',
      categoriesHint: 'une ou plusieurs',
      noCategories: 'Aucune catégorie.',
      submit: "Créer l'utilisateur",
      creating: 'Création…',
      created: '{{email}} créé — e-mail de bienvenue envoyé.',
      convertTitle: 'Changer la méthode de connexion',
      convertSubmit: 'Convertir',
    },
    actions: {
      menu: 'Actions',
      edit: 'Modifier…',
      manageGrants: 'Gérer les accès',
      resendWelcome: "Renvoyer l'e-mail de bienvenue",
      resetPassword: 'Envoyer une réinitialisation de mot de passe',
      reset2fa: 'Réinitialiser la 2FA',
      convertAuth: 'Changer la méthode de connexion',
      deactivate: 'Désactiver',
      activate: 'Activer',
      delete: 'Supprimer…',
      confirmDelete: 'Supprimer {{name}} ? Ses accès et appareils seront définitivement supprimés.',
    },
    toast: {
      welcomeSent: 'E-mail de bienvenue envoyé.',
      resetSent: 'E-mail de réinitialisation envoyé.',
      twofaReset: 'La 2FA a été réinitialisée.',
      converted: 'Méthode de connexion mise à jour.',
      updated: 'Utilisateur mis à jour.',
      deleted: 'Utilisateur supprimé.',
    },
    grants: {
      title: 'Gérer les accès — {{name}}',
      subtitle: 'Choisissez les collections et les documents que cette personne peut consulter.',
      collections: 'Collections',
      documents: 'Documents individuels',
      noCollections: 'Aucune collection disponible.',
      nonCollection: 'Non catégorisé',
      nonCollectionHint: '(documents dans aucune collection)',
      searchDocs: 'Rechercher un document à ajouter…',
      noDocs: 'Aucun document disponible.',
      added: 'Ajouté',
      saved: 'Accès mis à jour.',
      save: 'Enregistrer les accès',
    },
  },
  publishers: {
    title: 'Catégories',
    subtitle: 'Catégories internes qui publient des documents via UniPortal.',
    create: 'Nouvelle catégorie',
    cols: {
      name: 'Nom',
      slug: 'Identifiant',
      status: 'Statut',
      members: 'Éditeurs',
      documents: 'Documents',
      collections: 'Collections',
    },
    active: 'Actif',
    disabled: 'Désactivé',
    empty: 'Aucune catégorie. Créez la première pour commencer à publier.',
    dialog: {
      createTitle: 'Créer une catégorie',
      renameTitle: 'Renommer la catégorie',
      name: 'Nom',
      namePlaceholder: 'ex. HC Contractor Reports',
      slug: 'Identifiant (optionnel)',
      slugHint: "Lettres minuscules, chiffres et tirets. Utilisé dans les chemins de stockage et de synchronisation — non modifiable ensuite. Généré automatiquement à partir du nom si laissé vide.",
      submit: 'Créer la catégorie',
      creating: 'Création…',
      save: 'Enregistrer',
      saving: 'Enregistrement…',
    },
    actions: {
      menu: 'Actions',
      rename: 'Renommer',
      disable: 'Désactiver',
      enable: 'Activer',
      manageCollections: 'Gérer les collections',
      manageAdmins: 'Gérer les éditeurs',
      delete: 'Supprimer…',
      confirmDelete: 'Supprimer la catégorie « {{name}} » ? Cela supprime aussi ses collections et ses adhésions.',
    },
    collections: {
      title: 'Collections — {{name}}',
      subtitle: 'Groupes de documents au sein de cette catégorie (par ex. un par contractant).',
      add: 'Ajouter une collection',
      namePlaceholder: 'Nom de la collection',
      empty: 'Aucune collection pour le moment.',
      documentsCount: '{{count}} documents',
      delete: 'Supprimer',
      confirmDelete: 'Supprimer la collection « {{name}} » ?',
      close: 'Fermer',
    },
    admins: {
      title: 'Éditeurs — {{name}}',
      subtitle: 'Personnes autorisées à publier et gérer le contenu de cette catégorie.',
      search: 'Rechercher un utilisateur à ajouter comme éditeur…',
      current: 'Éditeurs actuels',
      none: 'Aucun éditeur.',
      noResults: 'Aucun utilisateur correspondant.',
      remove: 'Retirer',
      close: 'Fermer',
    },
    toast: {
      created: 'Catégorie « {{name}} » créée.',
      updated: 'Catégorie mise à jour.',
      deleted: 'Catégorie supprimée.',
      disabled: 'Catégorie désactivée.',
      enabled: 'Catégorie activée.',
      collectionCreated: 'Collection ajoutée.',
      collectionDeleted: 'Collection supprimée.',
      adminAdded: 'Éditeur ajouté.',
      adminRemoved: 'Éditeur retiré.',
      hasDocuments: 'Cette catégorie a encore des documents — désactivez-la plutôt.',
    },
  },
  collections: {
    title: 'Collections',
    subtitle:
      'Regroupez les documents d’une catégorie (p. ex. une collection par sous-traitant). Accordez l’accès à une collection à des utilisateurs et chaque document qu’elle contient — y compris les futurs dépôts SFTP/sync — leur devient accessible.',
    categoryLabel: 'Catégorie',
    new: 'Nouvelle collection',
    noCategory:
      'Vous n’administrez encore aucune catégorie. Demandez à un administrateur de la plateforme de vous ajouter comme éditeur.',
    empty: 'Aucune collection pour l’instant. Créez-en une pour commencer à regrouper des documents.',
    documentsCount: '{{count}} documents',
    systemBadge: 'Système',
    uncategorizedHint:
      'Valeur système par défaut — les documents sans collection y sont classés. Impossible à renommer ou supprimer.',
    edit: 'Modifier',
    delete: 'Supprimer',
    confirmDelete: 'Supprimer la collection « {{name}} » ? Cette action est irréversible.',
    hasDocuments: 'Cette collection contient encore des documents — déplacez-les ou retirez-les d’abord.',
    dialog: {
      createTitle: 'Créer une collection',
      editTitle: 'Modifier la collection',
      name: 'Nom',
      namePlaceholder: 'p. ex. Circet',
      slug: 'Slug (facultatif)',
      slugHint:
        'Lettres minuscules, chiffres et tirets. Utilisé dans les chemins de sync/dépôt — non modifiable ensuite. Généré automatiquement à partir du nom si laissé vide.',
      description: 'Description (facultatif)',
      descriptionPlaceholder: 'Ce que cette collection regroupe…',
      create: 'Créer',
      creating: 'Création…',
      save: 'Enregistrer',
      saving: 'Enregistrement…',
    },
    toast: {
      created: 'Collection « {{name}} » créée.',
      updated: 'Collection mise à jour.',
      deleted: 'Collection supprimée.',
    },
  },
  channels: {
    title: 'Dossiers de dépôt',
    subtitle:
      'Liez un dossier SFTP/sync surveillé à une collection. Tout HTML déposé y est publié automatiquement dans cette collection et devient accessible à toute personne déjà autorisée — aucune gestion par fichier.',
    categoryLabel: 'Catégorie',
    new: 'Nouveau dossier de dépôt',
    noCategory:
      'Vous n’administrez encore aucune catégorie. Demandez à un administrateur de la plateforme de vous ajouter comme éditeur.',
    empty: 'Aucun dossier de dépôt. Créez-en un pour qu’un pipeline publie en déposant des fichiers.',
    intoCollection: 'Publie dans',
    copyPath: 'Copier le chemin',
    delete: 'Supprimer',
    confirmDelete: 'Supprimer le dossier de dépôt « {{name}} » ? Les documents déjà publiés conservent leur accès.',
    dialog: {
      title: 'Créer un dossier de dépôt',
      subtitle: 'Choisissez la collection dans laquelle publier les fichiers déposés ici.',
      collection: 'Collection',
      collectionPlaceholder: 'Sélectionnez une collection…',
      noCollections: 'Créez d’abord une collection, puis liez-y un dossier de dépôt.',
      label: 'Libellé (facultatif)',
      labelPlaceholder: 'p. ex. Rapports hebdomadaires Circet',
      create: 'Créer',
      creating: 'Création…',
    },
    toast: {
      created: 'Dossier de dépôt créé.',
      deleted: 'Dossier de dépôt supprimé.',
    },
  },
  guide: {
    basic: {
      eyebrow: 'Guide',
      title: 'Bienvenue sur UniPortal',
      intro: 'UniPortal est votre espace de lecture sécurisé — les documents partagés avec vous, au même endroit.',
      cards: {
        documents: { title: 'Vos documents', body: 'Vous ne voyez que les documents partagés avec vous, regroupés par catégorie et collection sur votre page Documents.' },
        reading: { title: 'Lire un document', body: 'Cliquez sur un document pour l’ouvrir dans une visionneuse sécurisée en lecture seule, dans un nouvel onglet. Rien n’est téléchargé sur votre appareil.' },
        access: { title: 'Besoin d’un document ?', body: 'Si un document attendu n’apparaît pas, demandez à l’équipe qui partage des documents avec vous de vous accorder l’accès.' },
        security: { title: 'Connexion', body: 'Votre compte est protégé par un mot de passe et un code d’authentification à 6 chiffres, ou par votre compte Microsoft.' },
      },
    },
    hero: {
      eyebrow: 'Guide',
      title: 'Comment fonctionne UniPortal',
      intro: 'UniPortal permet aux équipes internes de publier des documents autonomes et de les partager en toute sécurité avec des utilisateurs externes — sans mot de passe ni lien à transférer, juste un accès accordé aux bonnes personnes.',
      flow: {
        publish: { title: 'Publier', body: 'Une équipe dépose un document' },
        organise: { title: 'Organiser', body: 'Il est classé en collections' },
        grant: { title: 'Accorder', body: 'L’accès est donné aux utilisateurs' },
        read: { title: 'Consulter', body: 'Ils le lisent, en lecture seule' },
      },
    },
    hierarchy: {
      title: 'La hiérarchie',
      subtitle: 'Les catégories contiennent des collections, qui contiennent des documents.',
      publisherTag: 'Catégorie · espace interne',
      publisherExample: 'Rapports sous-traitants HC',
      collections: { circet: 'Circet', ctl: 'CTL', nonCollection: 'Non catégorisé' },
      doc: {
        circet: { 0: 'Rapport hebdo — sem. 23', 1: 'Audit chantier — Anvers' },
        ctl: { 0: 'Rapport d’avancement — mai', 1: 'Liste de contrôle qualité' },
        nonCollection: { 0: 'Notes de lancement', 1: 'Reprise diverse' },
      },
      nonCollectionNote: 'Un dossier système, un par catégorie, qui contient automatiquement tout document non classé dans une collection.',
      legend: {
        publisher: { term: 'Catégorie', def: 'un espace interne d’Unifiber qui publie des documents.' },
        collection: { term: 'Collection', def: 'un groupe nommé de documents, p. ex. un par sous-traitant.' },
        document: { term: 'Document', def: 'un fichier HTML autonome partagé avec les utilisateurs.' },
      },
    },
    m2m: {
      title: 'Liens plusieurs-à-plusieurs',
      subtitle: 'Un même document peut se trouver à plusieurs endroits à la fois — le point subtil.',
      inBadge: 'est dans',
      linkBadge: 'est lié à',
      docCollections: {
        title: 'Un document, plusieurs collections',
        body: 'Le même document peut être classé dans plusieurs collections à la fois. Il apparaît dans chacune, mais il n’existe qu’un seul document derrière.',
        doc: 'Document',
        col: { circet: 'Circet', shared: 'Rapports partagés' },
      },
      docPublishers: {
        title: 'Un document, plusieurs catégories',
        body: 'Si une seconde catégorie dépose exactement le même fichier, UniPortal détecte le doublon et lie le document existant au lieu d’en stocker une copie.',
        deptA: 'Catégorie A',
        deptB: 'Catégorie B',
        primary: 'Propriétaire',
        secondary: 'Lié',
        oneDoc: 'Un seul document',
        note: 'La catégorie propriétaire est principale. Une seconde catégorie gère ses propres collections et accès pour le document, mais ne peut pas le supprimer.',
      },
    },
    access: {
      title: 'Qui voit quoi',
      subtitle: 'Un utilisateur externe ne voit que les documents qui lui sont accordés.',
      or: 'OU',
      pathA: { tag: 'Voie A', title: 'Accorder une collection entière', body: 'L’utilisateur peut lire tous les documents de cette collection — y compris ceux ajoutés plus tard.' },
      pathB: { tag: 'Voie B', title: 'Accorder un seul document', body: 'L’utilisateur peut lire uniquement ce document, quelles que soient les collections auxquelles il appartient.' },
      result: { title: 'Un utilisateur voit un document si l’une des voies s’applique', body: 'Il dispose d’un accès direct au document, OU d’un accès à une collection dans laquelle se trouve le document.' },
      formula: { visible: 'Peut voir', docGrant: 'accès au document', or: 'OU', colGrant: 'accès à l’une de ses collections' },
    },
    roles: {
      title: 'Rôles & droits',
      subtitle: 'Trois types de comptes, aux pouvoirs très différents.',
      scopeLabel: 'Portée',
      viewer: {
        name: 'Lecteur standard',
        tagline: 'Lecteur externe',
        summary: 'Se connecte pour lire les documents qui lui sont partagés — rien de plus. Un espace de lecture épuré, en lecture seule.',
        can: ['Se connecter en toute sécurité (mot de passe + 2FA, ou Microsoft)', 'Voir uniquement les documents qui lui sont accordés', 'Lire les documents dans une visionneuse cloisonnée'],
        scope: 'Uniquement ses propres documents accordés',
      },
      publisher: {
        name: 'Éditeur',
        tagline: 'Personnel de publication',
        summary: 'Publie et gère les documents et collections d’une ou plusieurs catégories, et décide qui peut les lire.',
        can: ['Déposer et modifier les documents de sa ou ses catégories', 'Créer et organiser des collections', 'Accorder l’accès à n’importe quel utilisateur de la plateforme'],
        scope: 'Uniquement les catégories dont il fait partie',
      },
      admin: {
        name: 'Administrateur de la plateforme',
        tagline: 'Contrôle total',
        summary: 'Gère toute la plateforme — chaque catégorie, chaque utilisateur, chaque document et collection.',
        can: ['Gérer toutes les catégories', 'Créer et gérer tous les comptes utilisateurs', 'Superviser chaque document, collection et accès'],
        scope: 'L’ensemble de la plateforme',
      },
    },
  },
} as const;
